import React from 'react';
import kosarevPhoto from '../assets/images/kosarev-vsevolod.jpg';
import ContactLinks from './ContactLinks';
import { PROFILE, CV_PATH, CV_FILE_NAME } from '../data/resume';
import styles from '../pages/Resume.module.scss';

function ResumeHeader() {
    return (
        <div className={styles.header}>
            <div className={styles.headerContent}>
                <div className={styles.photoContainer}>
                    <img
                        src={kosarevPhoto}
                        alt={PROFILE.name}
                        className={styles.photo}
                    />
                </div>
                <div className={styles.headerInfo}>
                    <h1 className={styles.name}>{PROFILE.name}</h1>
                    <p className={styles.title}>{PROFILE.title}</p>
                    <p className={styles.location}>{PROFILE.currentLine}</p>

                    <ContactLinks />

                    {/* Статичный PDF собирается на этапе сборки (scripts/generate-cv-pdf.js),
                        поэтому ссылка работает и без JS, и для краулеров. */}
                    <a
                        className={styles.downloadCv}
                        href={CV_PATH}
                        type="application/pdf"
                        download={CV_FILE_NAME}
                    >
                        <svg
                            className={styles.downloadCvIcon}
                            viewBox="0 0 24 24"
                            width="18"
                            height="18"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden="true"
                        >
                            <path d="M12 3v12" />
                            <path d="m7 10 5 5 5-5" />
                            <path d="M5 21h14" />
                        </svg>
                        Download CV (PDF)
                    </a>
                </div>
            </div>
        </div>
    );
}

export default ResumeHeader;
